import { IApplicationState } from 'app/types/types';
import { IChatDashboardSettings } from 'app/store/model/chatDashboardSettings/types';
import { getChatDashboardSettingsInitial } from 'app/store/model/chatDashboardSettings/constants';

export const getChatDashboardSettingsByBoardId = (
    state: IApplicationState,
    boardId: number
): IChatDashboardSettings => {
    return state.model.chatDashboardsSettings[boardId] || getChatDashboardSettingsInitial() ;
};
